import DashboardScanCountMap from "./dashboardScanCountMap.container"

export default DashboardScanCountMap
